import React from 'react';

import type { ISVGElement } from 'components/icons/types';

export const ProfileWaitlistIcon = (props: ISVGElement) => (
  <svg width="24" height="24" viewBox="0 0 512 512" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" fill="#38A5FF" stroke="none">
      <path
        d="M945 5105 c-242 -41 -444 -144 -615 -315 -179 -179 -288 -401 -320
-650 -7 -60 -10 -676 -8 -2062 l3 -1977 21 -27 c11 -15 33 -37 48 -48 l27 -21
1877 0 1877 0 105 23 c195 43 355 108 501 205 332 219 547 535 630 927 32 151
33 412 1 556 -101 466 -379 820 -805 1025 -56 27 -108 49 -114 49 -10 0 -13
113 -13 530 l0 530 426 0 c416 0 427 1 461 21 68 43 85 113 62 276 -33 246
-143 466 -319 643 -177 176 -397 286 -643 319 -125 17 -3098 13 -3202 -4z
m2903 -1269 l2 -969 -97 6 c-309 19 -644 -79 -903 -262 -87 -61 -250 -220
-312 -303 l-50 -67 -707 -3 -707 -3 -41 -27 c-96 -63 -91 -211 9 -265 31 -17
78 -18 657 -21 l623 -3 -5 -22 c-3 -12 -17 -67 -31 -122 -29 -117 -46 -293
-39 -417 l6 -88 -589 0 c-555 0 -591 -1 -624 -19 -38 -20 -80 -88 -80 -130 0
-50 41 -114 90 -138 l44 -23 618 0 c499 0 618 -2 618 -13 0 -28 122 -257 182
-342 34 -49 109 -136 166 -192 l103 -103 -1233 2 -1233 3 0 1890 c0 2145 -7
1960 85 2150 123 252 373 423 655 448 22 2 659 3 1415 3 l1375 -1 3 -969z
m388 933 c255 -79 454 -278 533 -533 11 -37 21 -70 21 -72 0 -2 -142 -4 -315
-4 l-315 0 0 315 c0 173 2 315 4 315 2 0 35 -10 72 -21z m-360 -2224 c495 -87
876 -500 923 -999 40 -434 -168 -846 -539 -1070 -350 -212 -802 -212 -1155 -2
-274 163 -475 456 -530 770 -70 406 94 834 415 1081 137 105 326 190 493 220
100 18 287 18 393 0z"
      />
      <path
        d="M1050 4138 c-49 -25 -90 -89 -90 -139 0 -42 42 -110 80 -131 34 -17
76 -18 1052 -16 l1017 3 36 35 c81 79 62 205 -39 251 -39 18 -85 19 -1026 19
l-986 0 -44 -22z"
      />
      <path
        d="M1067 3186 c-20 -8 -45 -20 -54 -27 -22 -19 -53 -88 -53 -119 0 -45
36 -106 76 -131 l39 -24 1005 0 1005 0 35 22 c99 62 99 209 0 268 -35 20 -49
20 -1025 22 -811 2 -997 0 -1028 -11z"
      />
      <path
        d="M3651 1909 c-43 -9 -81 -37 -106 -80 -18 -31 -20 -52 -20 -234 0
-191 1 -202 23 -237 42 -68 81 -78 293 -78 172 0 188 2 229 23 33 16 51 34 68
67 27 55 28 82 1 136 -32 67 -70 85 -194 92 l-105 5 0 90 c0 71 -4 100 -20
133 -32 66 -98 98 -169 83z"
      />
    </g>
  </svg>
);

